<template>
  <div class="relative h-4 w-4 text-white mb-0 flex-none" :class="{ 'opacity-70': disabled }">
    <input
      :id="id"
      class="box-content absolute top-0 left-0 w-full h-full appearance-none border border-gray-300 rounded"
      type="checkbox"
      :name="name"
      :class="[`focus_ring-copper-900 focus_ring ${variant} bg-${background}`, { error, 'cursor-pointer': !disabled }]"
      :checked="modelValue"
      :disabled="disabled"
      @input="$emit('update:modelValue', ($event.target as HTMLInputElement).checked)"
    />
    <MinusSmallIcon
      v-if="partial"
      class="check-icon pointer-events-none absolute top-0 left-0 w-full h-full rounded hidden"
      :style="color && { background: color }"
    />
    <CheckIcon
      v-else
      class="check-icon pointer-events-none absolute top-0 left-0 w-full h-full rounded hidden"
      :style="color && { background: color }"
    />
  </div>
</template>

<script lang="ts">
export type CheckboxVariant = 'primary' | 'secondary'
</script>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { CheckIcon } from '@heroicons/vue/24/outline'
import { MinusSmallIcon } from '@heroicons/vue/24/solid'

defineProps({
  id: {
    type: String,
    default: null,
  },
  name: {
    type: String,
    default: null,
  },
  modelValue: {
    type: Boolean,
    default: null,
  },
  partial: {
    type: Boolean,
    default: false,
  },
  variant: {
    type: String as PropType<CheckboxVariant>,
    default: 'primary',
  },
  color: {
    type: String,
    default: null,
  },
  error: {
    type: Boolean,
    default: false,
  },
  background: {
    type: String,
    default: 'transparent',
  },
  disabled: {
    type: [Boolean, String] as PropType<boolean | 'true' | 'false'>,
    default: false,
  },
})

defineEmits(['update:modelValue'])
</script>

<style lang="stylus" scoped>
.primary:checked
  @apply border-copper-800

  & ~ .check-icon
    @apply bg-copper-800 border-copper-800 block

.secondary:checked
  @apply border-gray-900

  & ~ .check-icon
    @apply bg-gray-900 border-gray-900 block

.error
  @apply border-red-500
</style>
